import { useCallStorage } from '$logic/call'
import { MeetingBar } from '../meeting-bar'
import { ChannelCallBar } from '../channel-call-bar'
import { PvCallBar } from '../pv-call-bar'

export function CallBar({ isInRoom }: { isInRoom?: boolean }) {
  const { callType, roomId } = useCallStorage()

  return !roomId ? null : callType === 'call' ? (
    <PvCallBar isInRoom={isInRoom} />
  ) : callType === 'group_call' ? (
    <MeetingBar isInRoom={isInRoom} />
  ) : callType === 'live' || callType === 'tribune' ? (
    <ChannelCallBar isInRoom={isInRoom} callType={callType} />
  ) : null
}

CallBar.defaultProps = {
  isInRoom: false,
}
